var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-view__heading",attrs:{"data-testid":"elem_u_003697"}},[_c('h1',{staticClass:"admin-view__title",attrs:{"data-testid":"elem_u_003698"}},[_vm._v(" Affiliate Details ")]),_c('a',{staticClass:"admin-view__link",attrs:{"data-testid":"elem_u_003699"},on:{"click":_vm.clickOnBackLink}},[_vm._v(" Go back ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }